import { pinyinUtil } from './pinyinUtil';
import { AllTrim,tcheckUR} from './common_fun';


export default {
  install(Vue) {
    Vue.mixin({
      data: function() {
        return {
          dict:{},
          // pinyinUtil:{}
      }},
      mounted () {
        },
      methods: {
        goPost () {
			let distance = document.documentElement.scrollTop || document.body.scrollTop; //获得当前高度
			let step = distance / 30; //每步的距离
			(function jump() {
				if (distance > 0) {
					distance -= step;
					window.scrollTo(0, distance);
					setTimeout(jump, 10);
				}
			})();
		},
        //app 用户登录跳转封装
        goLinks(path, query = {}) {
            this.$router.push({ path, query });
        },
        getUrl(){
           let url = window.location.href;
    　　　　return url;
    　　},
                  // 获取用户信息
        getInfo(){
            this.$axios
            .get(this.interfaceJson.serverAddress+"/api/user/info")
            .then(res => {
            let data=res.data;
            if(data.code==0){
                if(data.data){
                    this.$store.dispatch("setUser", data.data); 
                    sessionStorage.setItem('info',JSON.stringify(data.data))
                    sessionStorage.setItem('zsMode',data.data.zs)
                }
            }
            });
        },
        yourname_ok(str1,str2) {
            let cnxing=str2.substr(0,1)
            let cnming=str2.substr(1,2)
            let xing=pinyinUtil.getPinyin(cnxing, '', false, true)
            let ming=pinyinUtil.getPinyin(cnming, '', false, true)
            if(str1==xing+ming||str1==ming+xing){
                return true;
            }else {
                return false;
            }
        },
        getPinyin(str){
            return pinyinUtil.getPinyin(str, ' ', false, true)
        },
        compare_nospace(str1,str2) {
            str1=AllTrim(str1)
            if(str1===str2){
                return true;
            }else {
                return false;
            }
        },
        compare_nospaces(str1, str2) {
            str1 = AllTrim(str1).toLowerCase();
            str2 = AllTrim(str2).toLowerCase();
            if (str1 === str2) {
                return true;
            } else {
                return false;
            }
        },
        noChinese(str1) {
            var patrn =/[^\x00-\xff]/ig;
            if (!patrn.test(str1)) {
                return true;
            } else {
                return false;
            }
        },
        city_delshi(str1) {
            str1=AllTrim(str1);
            str1=str1.toLowerCase()
            if(str1.substr(str1.length-3,3)==="shi"){
                str1=str1.substr(0,str1.length-3)
            }
            return str1
        },
        state_delsheng(str1) {
            str1=AllTrim(str1);
            str1=str1.toLowerCase()
            if(str1.substr(str1.length-5,5)==="sheng"){
                str1=str1.substr(0,str1.length-5)
            }
            return str1
        },
        email_ok(str1,str2) {
            if(this.compare_nospace(str1,str2)){
                return true;
            } else {
                return false;
            }
        },
     
        address1_ok(str1) {
            let reg = /[^\x00-\xff]/ig;//判断是否存在中文和全角字符
             //    var reg=/[A-Za-z]*[a-z0-9_-]|\s$/;//判断是否包含数字字母下划线  当使用这个时如果只有部分是中文字符还可以使用英文字体
            if (reg.test(str1)){
                return false;
            } else {
                return true;
            }
        },
        address2_ok(str1) {
            let reg = /[^\x00-\xff]/ig;//判断是否存在中文和全角字符
            if(str1.length==0){
                return true;
            }
            if (reg.test(str1)){
                return false;
            } else {
                return true;
            }
        },
  
        //   带市reg5
        city_ok(str1,str2) {
            if(str2){
                str1=this.city_delshi(str1);
                if (str2.substr(str2.length-1,1).trim()==='市'){
                    str2=str2.substr(0,str2.length-1)
                }
            
                if(str1.substr(str1.length-3,3)==="shi"){
                
                    str1=str1.substr(0,str1.length-3)
                }
      
                str2=pinyinUtil.getPinyin(str2,'', false, true);
                if(str1===str2){
                    return true;
                }else {
                    return false;
                }
            }
        },
        Ncity_delshi(str1) {
            str1 = AllTrim(str1);
            // str1 = str1.toLowerCase()
            if (str1.substr(str1.length - 1, 1) === "市") {
                str1 = str1.substr(0, str1.length - 1)
            }
            return str1
        },
        Nstate_delsheng(str1) {
            str1 = AllTrim(str1);
            // str1 = str1.toLowerCase()
            if (str1.substr(str1.length - 1, 1) === "省") {
                str1 = str1.substr(0, str1.length - 1)
            }
            return str1
        }, Naddress1_ok(str1) {
            let reg = /[^\x00-\xff]/ig;
            if (reg.test(str1)) {
                return true;
            } else {
                return false;
            }
        }, Naddress2_ok(str1) {
            if (str1) {
                let reg = /[^\x00-\xff]/ig;
                if (reg.test(str1)) {
                    return true;
                } else {
                    return false;
                }
            }else{
                return true;
            }
            
        },
        Ndistrict_ok(str1,str2) {
            if (str2.substr(str2.length-1,1).trim()==='市'){
                str2=str2.substr(0,str2.length-1)
            }
            if (str1.substr(str1.length-1,1).trim()==='市'){
                str1=str1.substr(0,str1.length-1)
            }
            if(str1.substr(str1.length-3,3)==="shi"){
            
                str1=str1.substr(0,str1.length-3)
            }
            if(str2.substr(str2.length-3,3)==="shi"){
            
                str2=str2.substr(0,str2.length-3)
            }
            if (this.compare_nospace(str1, str2)) {
                return true;
            } else {
                return false;
            }
        },
        district1_ok(str1,str2) {
            str2 = pinyinUtil.getPinyin(str2,'', false, true);
            if (this.compare_nospace(str1, str2)) {
                return true;
            } else {
                return false;
            }
        },
        Nstate_ok(str1,str2) {
            if(str2){
                str1=this.Nstate_delsheng(str1);
                if (str2.substr(str2.length-1,1).trim() ==='省'){
                    str2=str2.substr(0,str2.length-1)
                }
                if(str1===str2){
                    return true;
                }else {
                    return false;
                }
            }
        },
        Ncity_ok(str1,str2) {
            if(str2){
              str1=this.Ncity_delshi(str1);
              if (str2.substr(str2.length-1,1).trim()==='市'){
                  str2=str2.substr(0,str2.length-1)
              }
              if(str1.substr(str1.length-3,3)==="shi"){
               
                  str1=str1.substr(0,str1.length-3)
              }
              if(str1===str2){
                  return true;
              }else {
                  return false;
              }
            }
          
        },
        NCard_ValidDate(str1,str3) {
            let h  = str1.slice(0,3) +str1.slice(5,7)
              if (str3===h){
                  return true;
              } else{
                  return false;
              }
          },
       //   带省reg5
        state_ok(str1,str2) {
            if(str2){
                str1=this.state_delsheng(str1);
                if (str2.substr(str2.length-1,1).trim() ==='省'){
                    str2=str2.substr(0,str2.length-1)
                }
                str2=pinyinUtil.getPinyin(str2,'', false, true);
                if(str1===str2){
                    return true;
                }else {
                    return false;
                }
            }
        },
        countrycn_ok(str1) {
            if(str1){
                str1=AllTrim(str1)
                str1=str1.toLowerCase()
                if(str1==="中国"||str1==="china"){
                    return true;
                }  else {
                    return false;
                }
            }
        },
       countryus_ok(str1) {
            str1=AllTrim(str1)
            str1=str1.toLowerCase()
            if(str1==="美国"||str1==="unitedstates"){
                return true;
            }  else {
                return false;
            }
        },
        pincode_ok(str1,str2) {
            if (this.compare_nospace(str1,str2)){
                return true;
            } else {
                return false;
            }
        },
        displayname_ok(str1) {
            let reg = /[^\x00-\xff]/ig;//判断是否存在中文和全角字符
            str1=AllTrim(str1);
            if(reg.test(str1)){
              return false;
            } else{
              return true;
            }
        },
         checkURL (URL){
            let str=URL;
            let Expression=/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
            let objExp=new RegExp(Expression);
            if(objExp.test(str)==true){
                return true;
            }else{
                return false;
            }
        },
        phone_ok(str1,str2) {
            str1=AllTrim(str1)
            str1=str1.replace('+86', "");
            if (str1===str2){
                return true;
            }else {
                return false;
            }
        },
       CreditCard_ok(str1,str2) {
          if(this.compare_nospace(str1,str2)){
              return true;
          } else {
              return false;
          }
      },
       Card_ValidDate(str1,str2,str3) {
          str1=str1.substr(2,2)
          if (str3===str2+"/"+str1){
              return true;
          } else{
              return false;
          }
      },
       routingnum_ok(str1,str2) {
          if(this.compare_nospace(str1,str2)){
              return true;
          }else {
              return false;
          }
      },
       benType_ok(str1) {
          str1=AllTrim(str1.toLowerCase())
          if(str1==="公司"||str1==="corporation"){
              return true;
          }else{
              return false;
          }
      },
       OrganizationName_ok(str1,str2) {
            str2 = pinyinUtil.getPinyin(str2,'', false, true)
          if(this.compare_nospace(str1,str2)){
              return true;
          } else {
              return false;
          }
      },
       Disregarded_name_ok(str1) {
          if(str1.length>0){
              return false;
          } else {
              return true;
          }
      },
       entityType_ok(str1) {
          if(str1==="0"){
              return true;
          } else{
              return false;
          }
      },
       docNumber(str1,str2) {
          if(this.compare_nospace(str1,str2)){
              return true;
          }else{
              return false;
          }
      },
       yxdate_ok(str1,str2) {
          if(this.compare_nospace(str1,str2)){
              return true;
          } else {
              return false;
          }
      },
       firstname_ok(str1,str2) {
          str1=AllTrim(str1.toLowerCase());
          let cnxing=str2.substr(0,1)
          let cnming=str2.substr(1,2)
          let xing=pinyinUtil.getPinyin(cnxing,'', false, true)
          let ming=pinyinUtil.getPinyin(cnming,'', false, true)
          if(str1===ming){
              return true;
          }else {
              return false;
          }
      },
      yxDtae(str){
        str=str.split("-");
        str=str[2]+"/"+str[1]+"/"+str[0];
        return str;
      },
       yxdate_ok1(str1, str2) {
            str2=str2.split("-");
            str2=str2[2]+"/"+str2[1]+"/"+str2[0];
            if (this.compare_nospace(str1, str2)) {
            return true;
            } else {
            return false;
            }
        },
      getMing(str){
        let cnming=str.substr(0,1)
        return pinyinUtil.getPinyin(cnming,' ', false, true)
      },
      getXing(str){
        let cnxing=str.substr(1,2)
        return pinyinUtil.getPinyin(cnxing,' ', false, true)
      },
      getLastMing(str){
        let cnming=str.substr(0,1)
        return cnming
      },
      getLastXing(str){
        let cnxing=str.substr(1,2)
        return cnxing
      },
       lastname_ok(str1,str2) {
          str1=AllTrim(str1.toLowerCase());
          let cnxing=str2.substr(0,1)
          let cnming=str2.substr(1,2)
          let xing=pinyinUtil.getPinyin(cnxing,'', false, true)
          let ming=pinyinUtil.getPinyin(cnming,'', false, true)
          if(str1===xing){
              return true;
          }else {
              return false;
          }
      },
       cnfirstname_ok(str1,str2) {
          str1=AllTrim(str1.toLowerCase());
          let cnxing=str2.substr(0,1)
          let cnming=str2.substr(1,2)
        //   console.log(cnming)
          if(str1===cnming){
              return true;
          }else {
              return false;
          }
      },
       cnlastname_ok(str1,str2) {
          str1=AllTrim(str1.toLowerCase());
          let cnxing=str2.substr(0,1)
          let cnming=str2.substr(1,2)
          if(str1===cnxing){
              return true;
          }else {
              return false;
          }
      },
       businessName_ok(str1) {
        let reg = /[^\x00-\xff]/ig;//判断是否存在中文和全角字符
          str1=AllTrim(str1);
          if(str1.length==0){
              return false;
          }
          if(reg.test(str1)){
              return false;
          }else {
              return true;
          }
      },
       cnbusinessName_ok(str1,str2) {
          if(this.compare_nospace(str1,str2)){
              return false;
          }else {
              return true;
          }
      },
       businessLicenseNumber_ok(str1,str2) {
          if(this.compare_nospace(str1,str2)){
              return false;
          }else {
              return true;
          }
      },
      YourName_ok(s1,s2) {
         let str1=AllTrim(s1.toLowerCase());
         let str2=s2;
          if (this.yourname_ok(str1,str2)){
            return true;
          }else {
            return false;
          }
      }
      ,
      isChinese  (e) {
        var reg = /[^\x00-\xff]/ig;//判断是否存在中文和全角字符
        //    var reg=/[A-Za-z]*[a-z0-9_-]|\s$/;//判断是否包含数字字母下划线  当使用这个时如果只有部分是中文字符还可以使用英文字体
        if (reg.test(e)) {
            return true;//存在中文
        }
        return false;//不存在中文
    },
    //比较的字符串小写去空格处理
    compareStr(a,b) {
        a=a.toLowerCase()
        b=b.toLowerCase()
        a=a.replace(/\s+/g,"")
        b=b.replace(/\s+/g,"")
        console.log(a+'---'+b)
        if(a===b){
            return true;
        } else {
            return false;
        }
    },
    //你的名字
    youNameOK(s){
       if(s){
           if(this.compareStr(s,"Kumar Deep")){
               return 10;
           } else {
               return 0;
           }
       } else {
           return -1;
       }
   },
   //电话号码
   phoneOK(s) {
        if(s){
            if(s==="996823010"){
                return 8;
            }else {
                return 0
            }
        }else {
            return -1
        }
   },
   //邮箱
   emailOK(s) {
       if(s){
           if(this.compareStr(s,"KumarDeep_185@hotmail.com")){
               return 5;
           } else {
               return 0;
           }
       } else {
           return -1;
       }
   },
   //公司法定名称
    businessNameOK(s) {
        if(s) {
            if (this.compareStr(s,"Jhakaas Retail Private Limited")) {
                return 8;
            } else {
                return 0;
            }
        } else {
            return -1
        }
    },
//数组中查找
    findArr(s,arr) {
        s=s.toLowerCase()
        if(arr.indexOf(s)===-1){
            return false;
        } else {
            return true;
        }
    },
   //字符串是否为数字
    isRealNum(val){
        // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除，
        if(val === "" || val ==null){
            return false;
        }
        if(!isNaN(val)){
            //对于空数组和只有一个数值成员的数组或全是数字组成的字符串，isNaN返回false，例如：'123'、[]、[2]、['123'],isNaN返回false,
            //所以如果不需要val包含这些特殊情况，则这个判断改写为if(!isNaN(val) && typeof val === 'number' )
            return true;
        }
        else{
            return false;
        }
    },
    //店铺名称
    storeNameOK(s) {
        console.log(this.isChinese(s))
        if(s) {
            if (this.isChinese(s)) {
                return 0;
            } else {
                return 3;
            }
        } else {
            return -1
        }
    },
    //公司所在地邮编
    pincodeOK(s) {
        if(s){
            if(s==="400101"){
                return 5;
            }else {
                return 0
            }
        }else {
            return -1
        }
    },
    //公司地址栏
    addressOK(s) {
        if (s) {
            if (this.isChinese(s)) {
                return 0;
            } else {
                if(this.isRealNum(s)){
                    return 0;
                }else {
                    return 5;
                }
            }
        } else {
            return -1
        }
    },
    //公司所在城市
    cityOK(s) {
        if(s){
            if(this.compareStr(s,"Mumbai")){
                return 3;
            } else {
                return 0;
            }
        } else {
            return -1;
        }
    },
    //公司所在区域/州
     stateOK(s) {
        if(s){
            if(this.compareStr(s,"Maharashtra")){
                return 3;
            } else {
                return 0;
            }
        } else {
            return -1;
        }
    },
    //产品运送方式
    shipping_methodOK(s){
        if(s){
            if(s=='1'){
                return 3;
            } else {
                return 0;
            }
        } else {
            return -1;
        }
    },
//两步验证手机号
    phone2SVOK(s) {
        if(s){
            if(s==="981059899"){
                return 8;
            }else {
                return 0
            }
        }else {
            return -1
        }
    },
  //GST号码
    GSTOK(s) {
        if(s){
            if(this.compareStr(s,"27AAECJ0000N1Z8")){
                return 5;
            } else {
                return 0;
            }
        } else {
            return -1;
        }
    },
    //PAN号码
    PANOK(s) {
        if(s){
            if(this.compareStr(s,"AAECJ0000N")){
                return 5;
            } else {
                return 0;
            }
        } else {
            return -1;
        }
    },
    //运费明细
     feeOK(s) {
        if(s){
            if(s=='1'){
                return 3;
            }else {
                return 0
            }
        }else {
            return -1
        }
    },
    //银行账户明细-持有人姓名
     holderNameOK(s) {
        if(s) {
            if (this.compareStr(s,"Jhakaas Retail Private Limited")) {
                return 3;
            } else {
                return 0;
            }
        } else {
            return -1
        }
    },
    //银行账户明细-账户类型
     accountTypeOK(s) {
        if(s){
            if(s==3){
                return 3;
            } else {
                return 0;
            }
        } else {
            return -1;
        }
    },
    //银行账户明细-账号
    accountNumOK(s) {
        if(s){
            if(this.compareStr(s,"FPAYAMZ1111")){
                return 3;
            } else {
                return 0;
            }
        } else {
            return -1;
        }
    },
    //银行账户明细-IFSC代码
     IFSCOK(s) {
        if(s){
            if(this.compareStr(s,"CITI0101111")){
                return 3;
            } else {
                return 0;
            }
        } else {
            return -1;
        }
    },
    //默认产品税码
    TaxCodeOK(s) {
        if(s){
            if(s==7){
                return 3;
            } else {
                return 0;
            }
        } else {
            return -1;
        }
    }
      }
    });
  }
};
